var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isLoading)?_c(_setup.MiniCard,{attrs:{"title":_vm.name,"subtitle":_vm.country,"actions":_setup.actions,"metrics":_setup.metrics,"badge":_setup.badge,"icon":_setup.icon}}):_c(_setup.Loading,{attrs:{"loading":_setup.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }